export const PERIODO = {
  TRIMESTRAL: 1,
  MENSUAL: 2,
  ANUAL: 3,
} as const

export type PeriodoType = (typeof PERIODO)[keyof typeof PERIODO]
